const resources = {
  en: {
    forecastPage: {
      title: 'Forecast',
      description: 'Review recurring income and spending for the current month in one calendar view.',
      meta: {
        currentMonth: 'Current month: {{month}}',
      },
      calendarSection: {
        title: 'Monthly calendar',
        description: 'Projected recurring cash movements for {{month}}.',
      },
      realTransactions: {
        title: 'Actual transactions',
        description: 'Compare the forecast with the transactions already recorded this month.',
      },
      summary: {
        totalIncomeLabel: 'Planned income',
        totalExpensesLabel: 'Planned expenses',
        balanceLabel: 'Net forecast',
      },
      calendar: {
        unnamedEntry: 'Entry',
        expenseTooltipLine: '{{description}} — {{amount}}{{hours}}',
        incomeTooltipLine: '{{description}} — {{amount}}{{hours}}',
        expenseTag: '-{{amount}}{{hours}}',
        incomeTag: '+{{amount}}{{hours}}',
        summaryLabels: {
          income: 'Income planned for this day',
          expense: 'Expenses planned for this day',
          mixed: 'Income and expenses planned for this day',
          empty: 'No activity planned for this day',
        },
        summaryAria: '{{label}} on {{date}}',
        chipLabels: {
          income: 'Income',
          expense: 'Expenses',
        },
        chipAria: {
          income: '{{amount}} scheduled for {{date}}',
          expense: '{{amount}} scheduled for {{date}}',
        },
        drawer: {
          title: 'Details for {{date}}',
          income: 'Income',
          expense: 'Expenses',
          net: 'Net',
          noIncome: 'No income scheduled.',
          noExpense: 'No expenses scheduled.',
        },
      },
      errors: {
        load: 'Failed to load forecast',
      },
    },
  },
  uk: {
    forecastPage: {
      title: 'Прогноз',
      description: 'Переглядайте регулярні доходи та витрати поточного місяця в одному календарному вигляді.',
      meta: {
        currentMonth: 'Поточний місяць: {{month}}',
      },
      calendarSection: {
        title: 'Календар місяця',
        description: 'Прогнозовані регулярні рухи коштів за {{month}}.',
      },
      realTransactions: {
        title: 'Реальні транзакції',
        description: 'Порівнюйте прогноз із транзакціями, які вже зафіксовані цього місяця.',
      },
      summary: {
        totalIncomeLabel: 'Заплановані доходи',
        totalExpensesLabel: 'Заплановані витрати',
        balanceLabel: 'Чистий прогноз',
      },
      calendar: {
        unnamedEntry: 'Запис',
        expenseTooltipLine: '{{description}} — {{amount}}{{hours}}',
        incomeTooltipLine: '{{description}} — {{amount}}{{hours}}',
        expenseTag: '-{{amount}}{{hours}}',
        incomeTag: '+{{amount}}{{hours}}',
        summaryLabels: {
          income: 'Заплановані доходи на цей день',
          expense: 'Заплановані витрати на цей день',
          mixed: 'Заплановані доходи й витрати на цей день',
          empty: 'Активність не запланована на цей день',
        },
        summaryAria: '{{label}} на {{date}}',
        chipLabels: {
          income: 'Доходи',
          expense: 'Витрати',
        },
        chipAria: {
          income: '{{amount}} заплановано на {{date}}',
          expense: '{{amount}} заплановано на {{date}}',
        },
        drawer: {
          title: 'Деталі за {{date}}',
          income: 'Доходи',
          expense: 'Витрати',
          net: 'Баланс',
          noIncome: 'Доходів не заплановано.',
          noExpense: 'Витрат не заплановано.',
        },
      },
      errors: {
        load: 'Не вдалося завантажити прогноз',
      },
    },
  },
}

export default resources
